import { on } from "events";
import moment from "moment";
import React from "react";
import Datetime from "react-datetime";

export function AvailabilityListForm({
  availabilityList,
  setAvailabilityList,
  t,
  error,
  docStatus,
  docStatusLabel,
  contractTypes
}) {
  const AVAILABILITYTYPE = { immediate: 1, fixedDate: 2, preNotice: 3 };
  const DOCONLINESTATE = {
    available: 0,
    old: 1,
    sent: 2,
    longSent: 3,
    notAvailable: 4,
    unKnown: 5
  };
  function onChangeAvalabilityDate(date) {
    setAvailabilityList({
      ...availabilityList,
      availabilityDate: date._d
    });
  }

  function onChangeCheckbox({ target }) {
    setAvailabilityList({
      ...availabilityList,
      [target.name]: target.checked
    });
  }

  function onChangeAvalabilityType({ target }) {
    setAvailabilityList({
      ...availabilityList,
      availabilityType: Number(target.value),
      availabilityDate: null,
      NumberOfWeeks: null
    });
  }

  function onChange({ target }) {
    setAvailabilityList({
      ...availabilityList,
      [target.name]: target.value
    });
  }

  return (
    <div style={{ height: "500px", overflowY: "auto", overflowX: "hidden" }}>
      <div className="form-group m-2">
        <div className="label-wrapper">
          <label>{t("Skills *")}</label>
          {error.skills && <div className="error-msg">{error.skills}</div>}
        </div>
        <textarea
          rows={3}
          onChange={onChange}
          value={availabilityList.skills || ""}
          name="skills"
          maxLength="500"
          style={{ resize: "none" }}
        ></textarea>
      </div>
      <div className="form-group m-2">
        <div className="label-wrapper">
          <label>{t("Comment")}</label>
        </div>
        <textarea
          rows={3}
          onChange={onChange}
          value={availabilityList.comment || ""}
          name="comment"
          maxLength="500"
          style={{ resize: "none" }}
        ></textarea>
      </div>

      <div className="form-group  m-2">
        <div className="label-wrapper">
          <label>{t("Availability *")}</label>
          {(error.availabilityType ||
            error.availabilityDate ||
            error.numberOfWeeks) && (
            <div className="error-msg">
              {error.availabilityType}
              {error.availabilityDate} {error.numberOfWeeks}
            </div>
          )}
        </div>

        <div className="row">
          <div className="col-4">
            <select
              className="form-select"
              name="availabilityType"
              onChange={onChangeAvalabilityType}
              value={availabilityList.availabilityType || ""}
            >
              <option selected>{t("Choose a availability...")}</option>
              <option value={AVAILABILITYTYPE.immediate}>
                {t("Immediate")}
              </option>
              <option value={AVAILABILITYTYPE.fixedDate}>
                {t("Fixed Date")}
              </option>
              <option value={AVAILABILITYTYPE.preNotice}>
                {t("Pre-notice")}
              </option>
            </select>
          </div>
          <div className="col-4">
            {availabilityList.availabilityType ===
              AVAILABILITYTYPE.preNotice && (
              <input
                type="number"
                className="form-control"
                onChange={onChange}
                name="numberOfWeeks"
                value={availabilityList.numberOfWeeks || ""}
              />
            )}
            {availabilityList.availabilityType ===
              AVAILABILITYTYPE.fixedDate && (
              <Datetime
                timeFormat={false}
                value={
                  (availabilityList.availabilityDate &&
                    moment(availabilityList.availabilityDate).format(
                      "DD/MM/yyyy"
                    )) ||
                  t("Select Date")
                }
                closeOnSelect={true}
                utc={true}
                onChange={onChangeAvalabilityDate}
              />
            )}
          </div>
        </div>
      </div>
      <div className="form-group m-2">
        <div className="label-wrapper">
          <label>{t("Contract Type *")}</label>
          {error.userContractTypeId && (
            <div className="error-msg">{error.userContractTypeId}</div>
          )}
        </div>
        <div className="row">
          <div className="col-4">
            <select
              className="form-select"
              name="userContractTypeId"
              onChange={onChange}
              value={availabilityList.userContractTypeId || ""}
            >
              <option selected value="">
                {t("Choose a contract type...")}
              </option>
              {contractTypes?.map((contractType) => (
                <option key={contractType.id} value={contractType.id}>
                  {contractType.description}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="form-check form-check-inline m-2 ">
        <div className="label-wrapper"></div>
        <input
          className="form-check-input"
          type="checkbox"
          name={"forAll"}
          onChange={onChangeCheckbox}
          checked={availabilityList.forAll || false}
        />
        <label className="form-check-label" htmlFor={"forAll"}>
          {t("Available for all Companies")}
        </label>
      </div>
      <div>
        {docStatus != undefined && docStatus !== DOCONLINESTATE.available && (
          <div>
            {" "}
            <div className="form-check form-check-inline m-2 ">
              <div className="label-wrapper"></div>
              <input
                className="form-check-input"
                type="checkbox"
                name={"sendDocOnline"}
                onChange={onChangeCheckbox}
                checked={availabilityList.sendDocOnline || false}
              />
              <label className="form-check-label" htmlFor={"sendDocOnline"}>
                {t(docStatusLabel)}
              </label>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
